import React from 'react';
import PropTypes from 'prop-types';
import PlanTypeCard from '../PlanTypeCard';
import * as styles from './styles/styles.module.scss';

const PlanTypeCardCollection = ({ planTypes, handler, activePlanType, currencyCode, verifiedCoupon, isCouponApplied }) => {
  return planTypes.map(option => {
    return (
      <PlanTypeCard
        data-testid={`plan-${option.planCode}`}
        key={`plan-${option.planCode}`}
        option={option}
        handler={() => handler(option.planCode, option.recurlyPlanCode || null)}
        isActive={activePlanType === option.planCode}
        currencyCode={currencyCode}
        verifiedCoupon={verifiedCoupon}
        isCouponApplied={isCouponApplied}
        extraClasses={`${styles.card}`}
      />
    );
  });
};

PlanTypeCardCollection.propTypes = {
  planTypes: PropTypes.arrayOf(
    PropTypes.shape({
      allowCoupon: PropTypes.bool,
      numberOfMonths: PropTypes.string,
      planCode: PropTypes.string,
      priceMonth: PropTypes.number,
      priceTotal: PropTypes.number,
      showDiscount: PropTypes.bool
    })
  ),
  handler: PropTypes.func,
  activePlanType: PropTypes.string,
  currencyCode: PropTypes.string,
  isCouponApplied: PropTypes.bool
};

export default PlanTypeCardCollection;
